import { RECEIVING_OPTIONS_CONDITIONS } from '@/constants/fees'
import {
  FeesCondition,
  MerchantDiscountRates,
  PaymentsCardType,
  ReceivingOptionsType
} from '@/types/fees'

// Método que retorna as taxas por condições de antecipação
export const getFeesConditionsByReceivingOptions = (
  conditions: FeesCondition[],
  receivingOptions: ReceivingOptionsType
) => {
  const { anticipation_delay, liquidation_type } =
    RECEIVING_OPTIONS_CONDITIONS[receivingOptions]

  return conditions.find((condition) => {
    const isSameDelay = condition.anticipation_delay === anticipation_delay
    const isSameLiquidationType =
      condition.liquidation_type === (liquidation_type as string)

    return isSameDelay && isSameLiquidationType
  }) as FeesCondition
}

// Método que retorna as taxas por bandeiras de cartão
export const getFeesByPaymentsCard = (
  condition: FeesCondition,
  paymentCard: PaymentsCardType
) => {
  return condition.mdrs.filter(
    (mdr) => mdr.card_brand === paymentCard
  ) as MerchantDiscountRates[]
}

// Método que formata as taxas por grupo de bandeiras
export const formatFeesByFlagsGroup = (
  mainFlags: MerchantDiscountRates[],
  otherFlags: MerchantDiscountRates[]
) => {
  const mainFlagsFormatted = mainFlags.reduce((acc, flag) => {
    if (flag.payment_method === 'debit_card') {
      acc[0] = flag.installments[0].mdr as number
    }

    if (flag.payment_method === 'credit_card') {
      flag.installments.forEach((installment) => {
        acc[installment.installment] = installment.mdr as number
      })
    }

    return acc
  }, [] as number[])

  const otherFlagsFormatted = otherFlags.reduce((acc, flag) => {
    if (flag.payment_method === 'debit_card') {
      acc[0] = flag.installments[0].mdr as number
    }

    if (flag.payment_method === 'credit_card') {
      flag.installments.forEach((installment) => {
        acc[installment.installment] = installment.mdr as number
      })
    }

    return acc
  }, [] as number[])

  return {
    mainFlags: mainFlagsFormatted,
    otherFlags: otherFlagsFormatted
  }
}

// Método que formata a taxa para string
export const formatFeeToString = (fee: number): string => {
  return fee?.toFixed(2).toString().replace('.', ',').concat('%')
}

// Método que formata a moeda para string
export const formatValueToString = (value: number): string => {
  return `R$ ${value.toFixed(2).toString().replace('.', ',')}`
}

// Método que formata a moeda para string
export const formatValueToStringPtBR = (value: number): string => {
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}
